import { useAuthMutation } from './auth'
import { ApiStudentRequest, request } from '../utils'
import { useQueryClient } from '@tanstack/react-query'

type DeleteLanguageProficiencyByIdParams = {
  languageProficiencyId: string
}

export function useDeleteLanguageProficiency() {
  const queryClient = useQueryClient()

  const { isPending, mutate, mutateAsync } = useAuthMutation(
    async (params: DeleteLanguageProficiencyByIdParams) => {
      const url = `/documents/language-proficiencies/${params.languageProficiencyId}`

      return request(
        new ApiStudentRequest(url, {
          method: 'DELETE',
        }),
        {
          isExpectedResponse: (res: unknown): res is any => true,
        },
      )
    },
    {
      onSuccess: data => {
        // Invalidate language proficiency queries to refetch the data
        queryClient.invalidateQueries({
          queryKey: ['language-proficiency'],
        })
      },
    },
  )

  return {
    isDeletingLanguageProficiency: isPending,
    deleteLanguageProficiency: mutate,
    deleteLanguageProficiencyAsync: mutateAsync,
  }
}
